
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/disease-encyclopedia",
      function () {
        return require("private-next-pages/disease-encyclopedia/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/disease-encyclopedia"])
      });
    }
  